import { Card } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export default function ModalCard({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "h-full flex flex-col items-center justify-center mx-auto my-auto focus:outline-none",
        className
      )}
    >
      <Card className="w-full sm:min-w-[500px] sm:max-w-[500px] px-2 pt-4 !border-none sm:!border shadow-none">
        {children}
      </Card>
    </div>
  )
}
